import { DevelopmentTool } from '@wix/ambassador-devcenter-apps-v1-app-template/types';
import invert from 'lodash/invert';
import isEmpty from 'lodash/isEmpty';
import omitBy from 'lodash/omitBy';
import type { TemplateTab } from '../types/TemplateTabs';
import { QueryParams } from '../constants/QueryParams';
import type { BlocksTemplateUrlProps } from '../types/BlocksTemplateUrlProps';

export const VALID_APPLIED_FILTERS: TemplateTab[] = [
  DevelopmentTool.BLOCKS,
  DevelopmentTool.CLI,
  DevelopmentTool.DEV_CENTER,
];

export enum UrlParams {
  BLOCKS = 'blocks',
  CLI = 'cli',
  DEV_CENTER = 'self-hosted',
}

export const isValidAppliedFilter = (filter: TemplateTab) =>
  VALID_APPLIED_FILTERS.includes(filter);

export const filterToUrlParamMapper = {
  [DevelopmentTool.BLOCKS]: UrlParams.BLOCKS,
  [DevelopmentTool.CLI]: UrlParams.CLI,
  [DevelopmentTool.DEV_CENTER]: UrlParams.DEV_CENTER,
};

export const urlParamToFilterMapper = invert(filterToUrlParamMapper) as Record<
  UrlParams,
  TemplateTab
>;

export const getBlocksTemplateUrlParams = ({
  templateId,
  templateName,
  httpReferrer,
  namespace,
  namespaceType,
  entryFlow,
  otherParams,
}: BlocksTemplateUrlProps) => {
  const urlParams = {
    [QueryParams.TEMPLATE_ID]: templateId,
    [QueryParams.TEMPLATE_NAME]: templateName,
    [QueryParams.HTTP_REFERRER]: httpReferrer,
    [QueryParams.TEMPLATE_NAMESPACE]: namespace,
    [QueryParams.TEMPLATE_NAMESPACE_TYPE]: namespaceType,
    [QueryParams.ENTRY_FLOW]: entryFlow,
    ...otherParams,
  };

  return getUrlSearchParamsString(urlParams);
};

export const getUrlSearchParamsString = (
  params: Partial<Record<QueryParams, string>>,
) => new URLSearchParams(omitBy(params, isEmpty)).toString();
